import { Box, withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';

export const Dot = withStyles(({ spacing, palette }) => ({
  root: {
    width: spacing(1),
    height: spacing(1),
    margin: spacing(0, 0.3),
    borderRadius: '50%',
    background: palette.grey[200],
  },
}))(Box);

export const LogoWrapper = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(0.3, 0.1),
    borderRadius: spacing(0.1),
    marginRight: spacing(0.9),
    boxShadow: `0px 2px 4px rgba(0, 0, 0, 0.1)`,
    '& > svg': {
      display: 'block',
      maxHeight: 16,
    },
  },
}))(Box);

export const DotsGroup = withStyles(({ spacing, breakpoints }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    [breakpoints.up(375)]: {
      margin: spacing(0, 0.6),
    },
  },
}))(Box);

export const NumberEnding = withStyles(({ spacing, palette }) => ({
  root: {
    color: palette.grey[400],
    marginLeft: spacing(0.9),
  },
}))(FsBody);
